/* ============================================================
   FRÈRES — Rediseño 2026 · theme JS (vanilla)
   Cart (AJAX), top-sheet menu, gallery carousel, chips filter,
   accordions, PDP variant selection, sticky buy, toast.
   ============================================================ */
(function () {
  "use strict";
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var money = function (cents) { return "$" + Math.round(cents / 100).toLocaleString("es-AR"); };

  /* ---------- toast ---------- */
  var toastEl = $("#FreresToast"), toastT;
  function toast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg; toastEl.classList.add("is-on");
    clearTimeout(toastT); toastT = setTimeout(function () { toastEl.classList.remove("is-on"); }, 2200);
  }

  /* ---------- announcement rotator ---------- */
  (function () {
    var box = $("[data-announce]"); if (!box) return;
    var items = $$(".announce-track", box); if (items.length < 2) return;
    var i = 0;
    setInterval(function () {
      items[i].hidden = true;
      i = (i + 1) % items.length;
      items[i].hidden = false;
    }, 3800);
  })();

  /* ---------- nav solid on scroll ---------- */
  (function () {
    var nav = $("[data-nav]"); if (!nav) return;
    var onScroll = function () { nav.classList.toggle("nav--solid", window.scrollY > 24); };
    window.addEventListener("scroll", onScroll, { passive: true }); onScroll();
  })();

  /* ---------- panels (menu + cart) ---------- */
  function openPanel(panel, scrim) { if (panel) { panel.classList.add("is-on"); panel.setAttribute("aria-hidden", "false"); } if (scrim) scrim.classList.add("is-on"); document.documentElement.style.overflow = "hidden"; }
  function closePanel(panel, scrim) { if (panel) { panel.classList.remove("is-on"); panel.setAttribute("aria-hidden", "true"); } if (scrim) scrim.classList.remove("is-on"); document.documentElement.style.overflow = ""; }

  var menu = $("[data-menu]"), menuScrim = $("[data-menu-scrim]");
  var cart = $("[data-cart]"), cartScrim = $("[data-cart-scrim]");

  document.addEventListener("click", function (e) {
    var t = e.target;
    if (t.closest("[data-menu-open]")) { e.preventDefault(); openPanel(menu, menuScrim); }
    if (t.closest("[data-menu-close]") || t === menuScrim) { closePanel(menu, menuScrim); }
    if (t.closest("[data-cart-open]")) { e.preventDefault(); closePanel(menu, menuScrim); openCart(); }
    if (t.closest("[data-cart-close]") || t === cartScrim) { closePanel(cart, cartScrim); }
  });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") { closePanel(menu, menuScrim); closePanel(cart, cartScrim); } });

  /* ---------- menu tabs ---------- */
  (function () {
    var tabs = $$("[data-mtab]"); if (!tabs.length) return;
    tabs.forEach(function (tab) {
      tab.addEventListener("click", function () {
        tabs.forEach(function (t) { t.classList.remove("is-active"); t.setAttribute("aria-selected", "false"); });
        tab.classList.add("is-active");
        tab.setAttribute("aria-selected", "true");
        $$("[data-mpanel]").forEach(function (p) { p.hidden = p.getAttribute("data-mpanel") !== tab.getAttribute("data-mtab"); });
      });
    });
  })();

  /* ---------- cart ---------- */
  function fmtFreeShip() {
    var el = $("[data-cart]"); return el ? parseInt(el.getAttribute("data-free-ship") || "0", 10) : 0;
  }
  function renderCart(c) {
    $$("[data-cart-count]").forEach(function (n) { n.textContent = c.item_count; });
    var lbl = $("[data-cart-count-label]"); if (lbl) lbl.textContent = c.item_count;

    var T = fmtFreeShip();
    var msg = $("[data-ship-msg]"), bar = $("[data-ship-bar]");
    if (T > 0 && msg && bar) {
      var rem = Math.max(0, T - c.total_price);
      bar.style.width = Math.min(100, c.total_price / T * 100) + "%";
      msg.innerHTML = rem > 0
        ? 'Faltan <strong>' + money(rem) + '</strong> para el <strong>envío gratis</strong>.'
        : '¡Alcanzaste el <strong>envío gratis</strong>! ✦';
    }

    // Nudge 2da prenda al 50%: progreso si falta, "logrado" si ya llegó.
    var cartEl = $("[data-cart]"), nudge = $("[data-2off]");
    if (nudge && cartEl) {
      var on2 = cartEl.getAttribute("data-2off-on") === "1";
      var units2 = parseInt(cartEl.getAttribute("data-2off-units") || "2", 10) || 2;
      var nmsg = $("[data-2off-msg]"), ncta = $("[data-2off-cta]");
      var qty2 = (c.items || []).reduce(function (s, it) { return s + it.quantity; }, 0);
      if (!on2 || c.item_count === 0) {
        nudge.hidden = true;
      } else {
        nudge.hidden = false;
        if (qty2 >= units2) {
          nudge.classList.remove("is-progress"); nudge.classList.add("is-active");
          if (nmsg) nmsg.textContent = cartEl.getAttribute("data-2off-active") || "";
          if (ncta) ncta.hidden = true;
        } else {
          nudge.classList.remove("is-active"); nudge.classList.add("is-progress");
          var need2 = Math.max(1, units2 - qty2);
          if (nmsg) nmsg.textContent = (cartEl.getAttribute("data-2off-progress") || "").replace("{n}", need2);
          // CTA "Ver opciones" solo si hay sugeridos que no estén ya en el carrito
          var slot2 = $("[data-upsell-slot]"), cards2 = slot2 ? $$(".up-card", slot2) : [];
          var inCart2 = (c.items || []).map(function (it) { return String(it.product_id); });
          var hasSug = false;
          for (var i2 = 0; i2 < cards2.length; i2++) { if (inCart2.indexOf(cards2[i2].getAttribute("data-up-pid")) === -1) { hasSug = true; break; } }
          if (ncta) ncta.hidden = !hasSug;
        }
      }
    }

    var body = $("[data-cart-body]"), foot = $("[data-cart-foot]");
    if (!body) return;
    if (c.item_count === 0) {
      var tpl = $("[data-cart-empty]");
      body.innerHTML = tpl ? tpl.innerHTML : '<p class="cart-empty-sub">Tu carrito está vacío.</p>';
      if (foot) foot.hidden = true;
      return;
    }
    body.innerHTML = c.items.map(function (it) {
      var img = it.image ? '<img src="' + (it.image.indexOf('?') > -1 ? it.image + '&width=200' : it.image + '?width=200') + '" alt="">' : "";
      var priceHtml = (it.original_line_price && it.original_line_price > it.final_line_price)
        ? '<s class="ci-was">' + money(it.original_line_price) + '</s> <span class="ci-now">' + money(it.final_line_price) + '</span>'
        : money(it.final_line_price);
      return '' +
        '<div class="ci">' +
          '<div class="img-box ci-media" style="aspect-ratio:3/4">' + img + '</div>' +
          '<div class="ci-info">' +
            '<div class="ci-top"><span class="ci-name">' + it.product_title + ' <em>' + (it.variant_title || "") + '</em></span>' +
            '<button class="ci-rm" data-change="' + it.key + '" data-q="0">Quitar</button></div>' +
            '<div class="ci-bottom">' +
              '<div class="qty"><button data-change="' + it.key + '" data-q="' + (it.quantity - 1) + '">−</button>' +
              '<span>' + it.quantity + '</span>' +
              '<button data-change="' + it.key + '" data-q="' + (it.quantity + 1) + '">+</button></div>' +
              '<span class="ci-price">' + priceHtml + '</span>' +
            '</div>' +
          '</div>' +
        '</div>';
    }).join("");
    if (foot) { foot.hidden = false; var sub = $("[data-cart-subtotal]"); if (sub) sub.textContent = money(c.total_price); }
  }

  function getCart() { return fetch("/cart.js", { headers: { "Accept": "application/json" } }).then(function (r) { return r.json(); }); }
  function openCart() { openPanel(cart, cartScrim); getCart().then(function (c) { renderCart(c); loadUpsell(c); }); }

  /* Upsell del carrito: recomendados según el 1er item. Defensivo: si no hay
     recomendaciones disponibles o algo falla, el bloque queda oculto. */
  // Upsell: las cards se renderizan en el server (cart-drawer.liquid) como carrusel
  // horizontal. Acá ocultamos las que ya están en el carrito y mostramos el resto
  // (hasta 12) para que el cliente pueda scrollear y ver más productos.
  function loadUpsell(c) {
    var wrap = $("[data-cart-upsell]"), slot = $("[data-upsell-slot]");
    if (!wrap || !slot) return;
    var inCart = (c.items || []).map(function (it) { return String(it.product_id); });
    var shown = 0;
    $$(".up-card", slot).forEach(function (card) {
      if (inCart.indexOf(card.getAttribute("data-up-pid")) === -1 && shown < 12) {
        card.style.display = ""; shown++;
      } else {
        card.style.display = "none";
      }
    });
    if (slot.scrollLeft) slot.scrollLeft = 0;
    wrap.hidden = (shown === 0) || !c.items || !c.items.length;
  }

  function addToCart(variantId, qty) {
    return fetch("/cart/add.js", {
      method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty || 1 }] })
    }).then(function (r) { return r.json(); });
  }
  function changeCart(key, qty) {
    return fetch("/cart/change.js", {
      method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); });
  }

  document.addEventListener("click", function (e) {
    var add = e.target.closest("[data-add-to-cart]");
    if (add && !add.hasAttribute("data-pdp-add")) {
      e.preventDefault();
      var id = add.getAttribute("data-variant-id");
      if (!id) return;
      addToCart(id, 1).then(function (res) {
        if (res && res.status) { toast(res.description || "No se pudo agregar"); return; }
        toast("Agregado ✦"); openCart();
      });
    }
    var chg = e.target.closest("[data-change]");
    if (chg) {
      e.preventDefault();
      changeCart(chg.getAttribute("data-change"), parseInt(chg.getAttribute("data-q"), 10)).then(renderCart);
    }
    var off2 = e.target.closest("[data-2off-cta]");
    if (off2) {
      e.preventDefault();
      var upBox = document.querySelector("[data-cart-upsell]");
      if (upBox && !upBox.hidden) {
        upBox.scrollIntoView({ behavior: "smooth", block: "nearest" });
        upBox.classList.remove("is-flash");
        void upBox.offsetWidth; /* reinicia la animación */
        upBox.classList.add("is-flash");
        setTimeout(function () { upBox.classList.remove("is-flash"); }, 1300);
      }
    }
  });

  /* ---------- shop chips + density ---------- */
  (function () {
    $$("[data-chips]").forEach(function (chips) {
      var shop = chips.closest("[data-shop]");
      var grid = $("[data-shop-grid]", shop), count = $("[data-count]", shop);
      chips.addEventListener("click", function (e) {
        var btn = e.target.closest("[data-chip]"); if (!btn) return;
        $$(".chip", chips).forEach(function (c) { c.classList.remove("is-on"); });
        btn.classList.add("is-on");
        var tag = btn.getAttribute("data-chip");
        var shown = 0;
        $$(".card", grid).forEach(function (card) {
          var tags = card.getAttribute("data-tags") || "";
          var ok = !tag || tags.split("|").indexOf(tag) !== -1;
          card.style.display = ok ? "" : "none";
          if (ok) shown++;
        });
        if (count) count.textContent = shown + " productos";
      });
    });
    document.addEventListener("click", function (e) {
      var d = e.target.closest("[data-dens]"); if (!d) return;
      var bar = d.closest(".shop-bar"), shop = bar.closest("[data-shop]"), grid = $("[data-shop-grid]", shop);
      $$("[data-dens]", bar).forEach(function (b) { b.classList.remove("is-on"); });
      d.classList.add("is-on");
      grid.classList.toggle("shop-grid--large", d.getAttribute("data-dens") === "large");
    });
  })();

  /* ---------- accordions ---------- */
  document.addEventListener("click", function (e) {
    var head = e.target.closest("[data-acc-head]"); if (!head) return;
    var acc = head.closest("[data-acc]");
    var open = acc.classList.toggle("is-open");
    var body = $(".acc-body", acc), sign = $(".acc-sign", head);
    if (body) body.style.maxHeight = open ? "600px" : "0";
    if (sign) sign.textContent = open ? "−" : "+";
  });

  /* ---------- PDP gallery ---------- */
  (function () {
    var mainImg = $("[data-main-img]");
    $$("[data-thumb]").forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        $$("[data-thumb]").forEach(function (t) { t.classList.remove("is-on"); });
        thumb.classList.add("is-on");
        var img = $("img", thumb);
        if (mainImg && img) mainImg.src = img.src.replace(/_(\d+)x(\d+)?/, "_1400x").replace(/width=\d+/, "width=1400");
      });
    });
    var car = $("[data-carousel]"), prog = $("[data-progress]");
    if (car && prog) {
      var bar = prog.firstElementChild;
      car.addEventListener("scroll", function () {
        var max = car.scrollWidth - car.clientWidth;
        var frac = max > 0 ? car.scrollLeft / max : 0;
        bar.style.transform = "translateX(" + (frac * (prog.clientWidth - bar.offsetWidth)) + "px)";
      }, { passive: true });
    }
  })();

  /* ---------- PDP variant + qty + add ---------- */
  (function () {
    var pdp = $("[data-product]"); if (!pdp) return;
    var addBtns = $$("[data-pdp-add]");
    var qtyVal = $("[data-qty-val]"), qty = 1;
    var sizeGroups = $$("[data-sizes]");
    var optionCount = sizeGroups.length;
    var hasSizes = optionCount > 0;
    var chooseCount = 0; // opciones con +1 valor (las que el cliente realmente elige)
    sizeGroups.forEach(function (g) { if ($$("[data-size]", g).length > 1) chooseCount++; });
    var selectedVariant = null;
    var priceEl = $("[data-price]"), totalEl = $("[data-add-total]");
    var unitPrice = priceEl ? parsePrice(priceEl.textContent) : 0;

    function parsePrice(s) { return parseInt((s || "0").replace(/[^\d]/g, ""), 10) || 0; }
    function updateTotal() { if (totalEl && unitPrice) totalEl.textContent = "$" + (unitPrice * qty).toLocaleString("es-AR"); }

    // Variantes embebidas: packs = varias opciones (una por prenda). La variante
    // sale de combinar el talle elegido en cada selector.
    var variants = [];
    var vjson = $("[data-variants-json]");
    if (vjson) { try { variants = JSON.parse(vjson.textContent); } catch (e) { variants = []; } }
    var selected = []; for (var si = 0; si < optionCount; si++) selected.push(null);

    function findVariant() {
      for (var i = 0; i < selected.length; i++) if (selected[i] == null) return null;
      return variants.filter(function (v) {
        return v.options && v.options.length === selected.length &&
          v.options.every(function (o, i) { return o === selected[i]; });
      })[0] || null;
    }
    // ¿hay alguna variante disponible con este valor en esta opción, dadas las otras ya elegidas?
    function valuePossible(idx, val) {
      return variants.some(function (v) {
        if (!v.available || !v.options || v.options[idx] !== val) return false;
        for (var i = 0; i < selected.length; i++) {
          if (i === idx || selected[i] == null) continue;
          if (v.options[i] !== selected[i]) return false;
        }
        return true;
      });
    }
    function refresh() {
      sizeGroups.forEach(function (group) {
        var idx = parseInt(group.getAttribute("data-option-index"), 10);
        $$("[data-size]", group).forEach(function (btn) {
          var ok = valuePossible(idx, btn.getAttribute("data-size"));
          btn.disabled = !ok;
          btn.classList.toggle("is-out", !ok);
          if (!ok && btn.classList.contains("is-on")) { btn.classList.remove("is-on"); selected[idx] = null; }
        });
      });
      var v = findVariant();
      selectedVariant = v ? String(v.id) : null;
      if (selectedVariant) addBtns.forEach(function (a) { a.setAttribute("data-variant-id", selectedVariant); });
    }

    sizeGroups.forEach(function (group) {
      var idx = parseInt(group.getAttribute("data-option-index"), 10);
      $$("[data-size]", group).forEach(function (btn) {
        btn.addEventListener("click", function () {
          if (btn.disabled) return;
          $$("[data-size]", group).forEach(function (x) { x.classList.remove("is-on"); });
          btn.classList.add("is-on");
          selected[idx] = btn.getAttribute("data-size");
          refresh();
        });
      });
    });
    // Opciones de un solo valor (p. ej. Color con un único color) → auto-seleccionar
    // (van ocultas en el Liquid); así no traban el "Agregar al carrito".
    sizeGroups.forEach(function (group) {
      var only = $$("[data-size]", group);
      if (only.length === 1) {
        var idx = parseInt(group.getAttribute("data-option-index"), 10);
        only[0].classList.add("is-on");
        selected[idx] = only[0].getAttribute("data-size");
      }
    });
    if (hasSizes) refresh();

    var inc = $("[data-qty-inc]"), dec = $("[data-qty-dec]");
    if (inc) inc.addEventListener("click", function () { qty++; qtyVal.textContent = qty; updateTotal(); });
    if (dec) dec.addEventListener("click", function () { qty = Math.max(1, qty - 1); qtyVal.textContent = qty; updateTotal(); });

    addBtns.forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        if (hasSizes && !selectedVariant) { toast(chooseCount > 1 ? "Elegí el talle de cada prenda" : "Elegí un talle primero"); return; }
        var id = selectedVariant || btn.getAttribute("data-variant-id");
        addToCart(id, qty).then(function (res) {
          if (res && res.status) { toast(res.description || "No se pudo agregar"); return; }
          toast("Agregado ✦"); openCart();
        });
      });
    });

    /* sticky buy on scroll past main button */
    var sticky = $("[data-pdp-sticky]"), mainBuy = $(".pinfo-buy");
    if (sticky && mainBuy) {
      var onScroll = function () {
        var r = mainBuy.getBoundingClientRect();
        sticky.hidden = !(r.bottom < 0);
      };
      window.addEventListener("scroll", onScroll, { passive: true }); onScroll();
    }
  })();

  /* ---------- reveal on scroll (fade + translate) ----------
     Secciones (salvo el hero) y product cards entran suave al viewport.
     Anti-flash: marca <html>.js-reveal y pone [data-fr-reveal] solo si corre. */
  (function () {
    return; // REVEAL POR JS DESACTIVADO: el patrón "ocultar-por-defecto + revelar-con-JS" dejaba secciones/cards en blanco en producción si el observer no disparaba. Todo se muestra siempre. (código abajo queda inactivo a propósito).
    if (!("IntersectionObserver" in window)) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    document.documentElement.classList.add("js-reveal");

    var STEP = 70; // ms de stagger entre columnas de una misma fila

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add("is-inview");
        io.unobserve(e.target);
      });
    }, { threshold: 0.08, rootMargin: "0px 0px -6% 0px" });

    function arm(el) {
      el.setAttribute("data-fr-reveal", "");
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) {
        // ya visible al cargar → revelar enseguida (respeta su --fr-delay)
        requestAnimationFrame(function () { el.classList.add("is-inview"); });
      } else {
        io.observe(el);
      }
    }

    // Secciones del contenido principal — saltar la primera (hero, above-fold)
    $$("#MainContent > .shopify-section").forEach(function (sec, i) {
      if (i === 0) return;
      arm(sec);
    });

    // NOTA: el reveal de product cards quedó DESACTIVADO. En mobile, en páginas de
    // colección con muchas cards, algunas quedaban en opacity:0 sin revelarse
    // (categoría "en blanco"). Las cards ahora se muestran siempre; el reveal solo
    // aplica a las secciones. (col/STEP quedan sin uso intencionalmente.)

    // RED DE SEGURIDAD: si por cualquier motivo (observer que no dispara, error,
    // layout raro) algo armado no se reveló, lo mostramos igual a los 1.5s.
    // Garantiza que NADA quede jamás invisible.
    setTimeout(function () {
      $$("[data-fr-reveal]:not(.is-inview)").forEach(function (el) { el.classList.add("is-inview"); });
    }, 1500);
  })();

  /* ---------- carrusel de imágenes en product cards (sync de dots) ---------- */
  (function () {
    $$("[data-card-carousel]").forEach(function (car) {
      var dots = car.parentElement.querySelector("[data-card-dots]");
      if (!dots) return;
      var dotEls = $$(".card-dot", dots);
      car.addEventListener("scroll", function () {
        var i = Math.round(car.scrollLeft / car.clientWidth);
        dotEls.forEach(function (d, idx) { d.classList.toggle("is-on", idx === i); });
      }, { passive: true });
    });
  })();
})();
